import { gateway } from "../../../gateway";
import type { IInvoice } from "../../invoice/create/interfaces/invoice.interfaces";

interface IDataResponse<T> {
  status: number;
  message: string;
  data: T;
}

/** GET every deposit invoice ever issued for the quote (active, refunded, cancelled). */
export const getDepositInvoicesByQuote = async (quoteId: number): Promise<IInvoice[]> => {
  const res = await gateway.get<IDataResponse<IInvoice[]>>(`/quotes/${quoteId}/deposit-invoices`);
  return res.data?.data ?? [];
};

/**
 * POST a new deposit invoice; backend rejects with 409 if there is still an active one.
 * Pass `depositAmount` only when creating the very first deposit invoice for a quote that has
 * no `depositAmount` configured yet.
 */
export const reissueDepositInvoice = async (
  quoteId: number,
  payload?: { depositAmount?: number },
): Promise<{ depositInvoiceUid: string }> => {
  const res = await gateway.post<IDataResponse<{ depositInvoiceUid: string }>>(
    `/quotes/${quoteId}/deposit-invoices`,
    payload ?? {},
  );
  return res.data?.data;
};
